<template>
  <div class="filter_item">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "FilterItem",
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.filter_item {
  margin-bottom: 12px;
  padding: 0 18px 12px;
  border-bottom: 1px solid $border;

  &:not(:last-child) {
  }

  &:last-child {
    border-bottom: none;
  }
}
</style>
